import styled from 'styled-components';

export const BadgeContainer = styled.div`
    &&& {
        display: flex;
        align-items: center;
        grid-column: 1 / span 2;
        div:nth-child(2) {
            margin-left: 8px;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            grid-column: 2;
        }
    }
`;
